@if (query.error()?.status !== 403) {
  <app-user-list #list [page]="query.page()"
                 [scim]="scim.page()" />
} @else {
  <div class="error-403" i18n>Access Denied</div>
}
